import React, { Component } from 'react'
import { BrowserRouter, Redirect, Route, Switch, withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import withWebSocketConnection from './components/shared/withWebSocketConnection'
import { routerPaths } from './constants/paths'
import * as sessionHelpers from './helpers/sessionHelpers'
import { isProhibitedNotification } from './helpers/orderHelpers'
import SessionNew from './views/sessions/SessionNew'
import SessionDestroy from './views/sessions/SessionDestroy'
import TopNavBar from './components/TopNavBar'
import NotificationsContainer from './components/NotificationsContainer'
import Dashboard from './components/Dashboard'
import ShopOrdersIndex from './components/shop_orders/ShopOrdersIndex'
import ShopOrdersShow from './components/shop_orders/ShopOrdersShow'
import ShopOrderHistory from './components/shop_orders/ShopOrderHistory'
import ReconciliationsIndex from './components/shop_orders/ReconciliationsIndex'

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
    }
  }

  render() {
    return this.props.children;
  }
}

const WrappedScrollToTop = withRouter(ScrollToTop)
const WrappedTopNavBar = withRouter(TopNavBar)

class Router extends Component {
  state = {
    notifications: []
  }

  userSignedIn() {
    const authenticationToken = sessionHelpers.getApplicationCookie('authentication_token')

    return authenticationToken !== ''
  }

  preventDoubleSignIn(ComponentToRender, routeProps={}) {
    if (this.userSignedIn()) {
      return <Redirect to={routerPaths.shopOrdersIndex} />
    }
    else {
      return <ComponentToRender {...routeProps} />
    }
  }

  renderComponent(ComponentToRender, routeProps={}) {
    return <ComponentToRender {...routeProps} />
  }

  requireSignIn(ComponentToRender, routeProps={}) {
    if (this.userSignedIn()) {
      return <ComponentToRender {...routeProps} />
    }
    else {
      return <Redirect to={routerPaths.signIn} />
    }
  }

  onDataReceived(notificationData) {
    if (isProhibitedNotification(notificationData)) return

    this.props.dispatch({
      type: 'SHOP_ORDER_NOTIFICATIONS_UPDATE',
      payload: { data: notificationData }
    })
  }

  render() {
    return(
      <BrowserRouter>
        <WrappedScrollToTop>
          <WrappedTopNavBar />
          <NotificationsContainer />
          <Switch>
            <Route exact path={routerPaths.dashboard} render={(props) => this.requireSignIn(Dashboard, props)} />

            <Route exact path={routerPaths.reconciliationsIndex} render={(props) => this.requireSignIn(ReconciliationsIndex, props)} />

            <Route exact path={routerPaths.shopOrderHistory} render={(props) => this.requireSignIn(ShopOrderHistory, props)} />

            <Route exact path={routerPaths.shopOrdersShow} render={(props) => this.requireSignIn(ShopOrdersShow, props)} />

            <Route exact path={routerPaths.shopOrdersIndex} render={(props) => this.requireSignIn(ShopOrdersIndex, props)} />

            <Route exact path={routerPaths.signIn} render={(props) => this.preventDoubleSignIn(SessionNew, props)} />

            <Route exact path={routerPaths.signOut} render={(props) => this.renderComponent(SessionDestroy, props)} />
          </Switch>
        </WrappedScrollToTop>
      </BrowserRouter>
    )
  }
} //class Router

export default connect(() => ({}))(withWebSocketConnection(Router, 'AdminUserShopOrderChannel'))
